import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'
import * as constants from './constants'
import { PATCH_ASSISTANT_AGENT_SETTINGS } from '../assistantSettings/constants'
import * as actions from './actions'
import * as meetingApi from './api'
import {
  properties as userProperties
} from 'app/modules/user/properties/selectors'
import { updateUserPropertiesTheRightWay } from 'app/modules/user/properties/actions'
import { defaultNewMeetingType } from './models'
import { getApplication } from 'app/Application'

const googleOauthAcceptEpic = action$ =>
  action$.ofType(constants.GOOGLE_OAUTH_ACCEPT).switchMap(action => {
    return meetingApi
      .googleOauthAccept(action.payload)
      .map(() => actions.googleOauthAcceptSuccess())
      .catch(error => Observable.of(actions.googleOauthAcceptFailure()))
  })

const microsoftOauthAcceptEpic = action$ =>
  action$.ofType(constants.MICROSOFT_OAUTH_ACCEPT).switchMap(action => {
    return meetingApi
      .microsoftOauthAccept(action.payload)
      .map(() => actions.microsoftOauthAcceptSuccess())
      .catch(error => Observable.of(actions.microsoftOauthAcceptFailure()))
  })

const zoomOauthAcceptEpic = action$ =>
  action$.ofType(constants.ZOOM_OAUTH_ACCEPT).switchMap(action => {
    return meetingApi
      .zoomOauthAccept(action.payload)
      .map(() => actions.zoomOauthAcceptSuccess())
      .catch(error => Observable.of(actions.zoomOauthAcceptFailure()))
  })

const fetchCalendarStatusEpic = action$ =>
  action$.ofType(constants.FETCH_CALENDAR_STATUS).switchMap(() => {
    return meetingApi
      .fetchCalendarStatus()
      .map(response => actions.fetchCalendarStatusSuccess(response))
      .startWith(actions.fetchCalendarStatusPending())
      .catch(error => Observable.of(actions.fetchCalendarStatusFailure()))
  })

const triggerFetchGoogleCalendarsEpic = action$ =>
  action$
    .ofType(constants.FETCH_CALENDAR_STATUS_SUCCESS)
    .filter(action => action.payload.googleAuthed)
    .map(() => actions.fetchGoogleCalendars())

const fetchGoogleCalendarsEpic = action$ =>
  action$.ofType(constants.FETCH_GOOGLE_CALENDARS).switchMap(() => {
    return meetingApi
      .fetchGoogleCalendars()
      .map(response => actions.fetchGoogleCalendarsSuccess(response))
      .startWith(actions.fetchGoogleCalendarsPending())
      .catch(error => Observable.of(actions.fetchGoogleCalendarsFailure()))
  })

const fetchGoogleScopesEpic = action$ =>
  action$.ofType(constants.FETCH_GOOGLE_SCOPES).switchMap(() => {
    return meetingApi
      .fetchGoogleScopes()
      .map(response => actions.fetchGoogleScopesSuccess(response))
      .startWith(actions.fetchGoogleScopesPending())
      .catch(error => Observable.of(actions.fetchGoogleScopesFailure(error)))
  })

const fetchMicrosoftAdminConsent = action$ =>
  action$.ofType(constants.FETCH_MICROSOFT_ADMIN_CONSENT).switchMap(() => {
    return meetingApi
      .fetchMicrosoftAdminConsent()
      .map(response => actions.fetchMicrosoftAdminConsentSuccess(response))
      .startWith(actions.fetchMicrosoftAdminConsentPending())
      .catch(error => Observable.of(actions.fetchMicrosoftAdminConsentFailure(error)))
  })

const disconnectMicrosoftAdminConsentEpic = action$ =>
  action$.ofType(constants.DISCONNECT_MICROSOFT_ADMIN_CONSENT).switchMap(() => {
    return meetingApi
      .disconnectMicrosoftAdminConsent()
      .map(response => actions.disconnectMicrosoftAdminConsentSuccess(response))
      .startWith(actions.disconnectMicrosoftAdminConsentPending())
      .catch(error => Observable.of(actions.disconnectMicrosoftAdminConsentFailure(error)))
  })

const fetchMicrosoftManagedCalendarsEpic = action$ =>
  action$.ofType(constants.FETCH_MICROSOFT_MANAGED_CALENDARS).switchMap(() => {
    return meetingApi
      .fetchMicrosoftManagedCalendars()
      .map(response => actions.fetchMicrosoftManagedCalendarsSuccess(response))
      .startWith(actions.fetchMicrosoftManagedCalendarsPending())
      .catch(error => Observable.of(actions.fetchMicrosoftManagedCalendarsFailure(error)))
  })

const microsoftAdminManagedAccept = action$ =>
  action$.ofType(constants.MICROSOFT_ADMIN_MANAGED_ACCEPT).switchMap(action => {
    return meetingApi
      .microsoftAdminConsentAccept(action.payload)
      .map((response) => actions.microsoftAdminManagedAcceptSuccess(response))
      .catch(error => Observable.of(actions.microsoftAdminManagedAcceptFailure(error)))
  })
    
const triggerFetchMicrosoftCalendarsEpic = action$ =>
  action$
    .ofType(constants.FETCH_CALENDAR_STATUS_SUCCESS)
    .filter(action => action.payload.microsoftAuthed)
    .map(() => actions.fetchMicrosoftCalendars())

const fetchMicrosoftCalendarsEpic = action$ =>
  action$.ofType(constants.FETCH_MICROSOFT_CALENDARS).switchMap(() => {
    return meetingApi
      .fetchMicrosoftCalendars()
      .map(response => actions.fetchMicrosoftCalendarsSuccess(response))
      .startWith(actions.fetchMicrosoftCalendarsPending())
      .catch(error => Observable.of(actions.fetchMicrosoftCalendarsFailure()))
  })

const updateGoogleCalendarEpic = action$ =>
  action$.ofType(constants.UPDATE_GOOGLE_CALENDAR).switchMap(action => {
    return meetingApi
      .updateGoogleCalendar(action.payload)
      .map(response => actions.updateGoogleCalendarSuccess(action.payload))
      .startWith(actions.updateGoogleCalendarPending(action.payload))
      .catch(error => Observable.of(actions.updateGoogleCalendarFailure()))
  })

const updateMicrosoftCalendarEpic = action$ =>
  action$.ofType(constants.UPDATE_MICROSOFT_CALENDAR).switchMap(action => {
    return meetingApi
      .updateMicrosoftCalendar(action.payload)
      .map(response => actions.updateMicrosoftCalendarSuccess(action.payload))
      .startWith(actions.updateMicrosoftCalendarPending(action.payload))
      .catch(error => Observable.of(actions.updateMicrosoftCalendarFailure()))
  })

const disconnectGoogleCalendarEpic = action$ =>
  action$.ofType(constants.DISCONNECT_GOOGLE_CALENDAR).switchMap(() => {
    return meetingApi
      .disconnectGoogleCalendar()
      .map(() => actions.disconnectGoogleCalendarSuccess())
      .startWith(actions.disconnectGoogleCalendarPending())
      .catch(error => Observable.of(actions.disconnectGoogleCalendarFailure(error)))
  })

const disconnectMicrosoftCalendarEpic = action$ =>
  action$.ofType(constants.DISCONNECT_MICROSOFT_CALENDAR).switchMap(() => {
    return meetingApi
      .disconnectMicrosoftCalendar()
      .map(() => actions.disconnectMicrosoftCalendarSuccess())
      .startWith(actions.disconnectMicrosoftCalendarPending())
      .catch(error => Observable.of(actions.disconnectMicrosoftCalendarFailure(error)))
  })

const fetchMeetingSettingsEpic = action$ =>
  action$.ofType(constants.FETCH_MEETING_SETTINGS).mergeMap(() => {
    return meetingApi
      .fetchMeetingSettings()
      .map(meeting => actions.fetchMeetingSettingsSuccess(meeting))
      .startWith(actions.fetchMeetingSettingsPending())
      .catch(error => Observable.of(actions.fetchMeetingSettingsFailure(error)))
  })

const debouncedUpdateMeetingSettingsEpic = action$ =>
  action$
    .ofType(constants.DEBOUNCE_UPDATE_MEETING_SETTINGS)
    .debounceTime(500)
    .pluck('payload')
    .switchMap(payload => {
      return meetingApi
        .updateMeetingSettings(payload)
        .map(meeting => actions.updateMeetingSettingsSuccess(meeting))
        .startWith(actions.updateMeetingSettingsPending())
        .catch(error => Observable.of(actions.updateMeetingSettingsFailure(error)))
    })

const updateMeetingSettingsEpic = action$ =>
  action$
    .ofType(constants.UPDATE_MEETING_SETTINGS)
    .pluck('payload')
    .switchMap(payload => {
      return meetingApi
        .updateMeetingSettings(payload)
        .map(meeting => actions.updateMeetingSettingsSuccess(meeting))
        .startWith(actions.updateMeetingSettingsPending())
        .catch(error => Observable.of(actions.updateMeetingSettingsFailure(error)))
    })

const updateMeetingSettingsNewAppointmentsEpic = action$ =>
  action$.ofType(constants.UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS).mergeMap(action => {
    return meetingApi
      .updateMeetingSettingsNewAppointments(action.payload)
      .map(meeting => actions.updateMeetingSettingsNewAppointmentsSuccess(meeting))
      .startWith(actions.updateMeetingSettingsNewAppointmentsPending())
      .catch(error => Observable.of(actions.updateMeetingSettingsNewAppointmentsFailure(error)))
  })

const triggerUpdateSettingsSuccessNotificationEpic = action$ =>
  action$
    .ofType(constants.UPDATE_MEETING_SETTINGS_SUCCESS, constants.UPDATE_MEETING_TYPE_SUCCESS)
    .switchMap(() => {
      getApplication().actions.NotificationActions.pushNotification({
        content: 'Your meeting settings have been updated.',
      })
      return Observable.empty()
    })

const triggerUpdateSettingsFailureNotificationEpic = action$ =>
  action$.ofType(constants.UPDATE_MEETING_SETTINGS_FAILURE).switchMap(() => {
    getApplication().actions.NotificationActions.pushNotification({
      content: 'Sorry, there was an error and we weren’t able to save your changes. Please try again.',
      variant: 'red',
    })
    return Observable.empty()
  })

const deleteMeetingTypeEpic = action$ =>
  action$.ofType(constants.DELETE_MEETING_TYPE).mergeMap(action => {
    return meetingApi
      .deleteMeetingType(action.payload)
      .map(() => actions.deleteMeetingTypeSuccess())
      .startWith(actions.deleteMeetingTypePending())
      .catch(error => Observable.of(actions.deleteMeetingTypeFailure(error)))
  })

const triggerDeleteMeetingTypeSuccessNotificationEpic = action$ =>
  action$
    .ofType(constants.DELETE_MEETING_TYPE_SUCCESS)
    .do(() => {
      getApplication().actions.NotificationActions.pushNotification({
        content: 'Your meeting type was deleted.',
      })
    })
    .map(() => actions.fetchMeetingTypes())

const triggerDeleteMeetingTypeFailureNotificationEpic = action$ =>
  action$.ofType(constants.DELETE_MEETING_TYPE_FAILURE).mergeMap(() => {
    getApplication().actions.NotificationActions.pushNotification({
      content: 'Your meeting type could not be deleted. Please chat with us to report this issue.',
    })
    return Observable.empty()
  })

const shareCalendarEpic = action$ =>
  action$.ofType(constants.SHARE_CALENDAR).mergeMap(action => {
    return meetingApi
      .sendShareCalendarMessage(action.payload)
      .map(response => actions.shareCalendarSuccess(response))
      .catch(error => {
        getApplication().actions.NotificationActions.pushNotification({
          content: 'Sorry, there was an error sharing this calendar. Please try again.',
          variant: 'red',
        })
        return Observable.of(actions.shareCalendarFailure(error))
      })
  })

const shareRoutedCalendarEpic = action$ =>
  action$.ofType(constants.SHARE_ROUTED_CALENDAR).mergeMap(action => {
    return meetingApi
      .sendShareRoutedCalendarMessage(action.payload)
      .map(response => actions.shareRoutedCalendarSuccess(response))
      .catch(error => {
        getApplication().actions.NotificationActions.pushNotification({
          content: 'Sorry, there was an error sharing this calendar. Please try again.',
          variant: 'red',
        })
        return Observable.of(actions.shareRoutedCalendarFailure(error))
      })
  })

const fetchConnectedCalendarsEpic = action$ =>
  action$.ofType(constants.FETCH_CONNECTED_CALENDARS).mergeMap(() => {
    return meetingApi
      .fetchConnectedCalendars()
      .map(agentIds => actions.fetchConnectedCalendarsSuccess(agentIds))
      .startWith(actions.fetchConnectedCalendarsPending())
      .catch(error => Observable.of(actions.fetchConnectedCalendarsFailure(error)))
  })

const fetchMeetingTypesEpic = action$ =>
  action$.ofType(constants.FETCH_MEETING_TYPES).switchMap(() => {
    return meetingApi
      .fetchMeetingTypes()
      .map(meetingTypes => actions.fetchMeetingTypesSuccess(meetingTypes))
      .startWith(actions.fetchMeetingTypesPending())
      .catch(() => Observable.of(actions.fetchMeetingTypesFailure()))
  })

const updateMeetingTypeEpic = action$ =>
  action$
    .ofType(constants.UPDATE_MEETING_TYPE)
    .debounceTime(500)
    .pluck('payload')
    .switchMap(meetingSettings => {
      return meetingApi
        .updateMeetingSettings(meetingSettings)
        .map(() => actions.updateMeetingTypeSuccess(meetingSettings))
        .startWith(actions.updateMeetingTypePending())
        .catch(error => Observable.of(actions.updateMeetingTypeFailure(error)))
    })

const fetchCalendlyMeetingTypesEpic = action$ =>
  action$
    .ofType(constants.FETCH_CALENDLY_MEETING_TYPES)
    .pluck('payload')
    .mergeMap(apiKey => {
      return meetingApi
        .fetchCalendlyMeetingTypes(apiKey)
        .flatMap(calendlyMeetingTypes => {
          const defaultAvailability = defaultNewMeetingType.get('availability')
          return [
            actions.fetchCalendlyMeetingTypesSuccess(),
            ...calendlyMeetingTypes.map(meetingType =>
              actions.updateMeetingType(
                meetingType
                  .set('availability', defaultAvailability)
                  .set('timezone', 'America/New_York')
                  .toJS()
              )
            ),
          ]
        })
        .startWith(actions.fetchCalendlyMeetingTypesPending())
        .catch(error => Observable.of(actions.fetchCalendlyMeetingTypesFailure(error)))
    })

const hasSeenPersonalizationTooltip = (action$, { getState }) =>
  action$
    .ofType(
      constants.UPDATE_MEETING_SETTINGS,
      PATCH_ASSISTANT_AGENT_SETTINGS,
      constants.UPDATE_GOOGLE_CALENDAR,
      constants.UPDATE_MICROSOFT_CALENDAR,
      constants.OPENED_MEETING_EMAIL_MODAL
    )
    .filter(() =>
      !userProperties(getState()).get('HAS_SEEN_PERSONALIZE_MEETING_EMAILS_EDUCATION', false))
    .map(() => updateUserPropertiesTheRightWay({ "HAS_SEEN_PERSONALIZE_MEETING_EMAILS_EDUCATION": true }, false))

export default combineEpics(
  googleOauthAcceptEpic,
  microsoftOauthAcceptEpic,
  zoomOauthAcceptEpic,
  fetchCalendarStatusEpic,
  fetchGoogleScopesEpic,
  triggerFetchGoogleCalendarsEpic,
  triggerFetchMicrosoftCalendarsEpic,
  fetchGoogleCalendarsEpic,
  fetchMicrosoftCalendarsEpic,
  updateGoogleCalendarEpic,
  updateMicrosoftCalendarEpic,
  disconnectGoogleCalendarEpic,
  disconnectMicrosoftCalendarEpic,
  fetchMeetingSettingsEpic,
  fetchMeetingTypesEpic,
  fetchCalendlyMeetingTypesEpic,
  updateMeetingTypeEpic,
  updateMeetingSettingsEpic,
  debouncedUpdateMeetingSettingsEpic,
  deleteMeetingTypeEpic,
  updateMeetingSettingsNewAppointmentsEpic,
  triggerUpdateSettingsSuccessNotificationEpic,
  triggerUpdateSettingsFailureNotificationEpic,
  triggerDeleteMeetingTypeSuccessNotificationEpic,
  triggerDeleteMeetingTypeFailureNotificationEpic,
  shareCalendarEpic,
  fetchConnectedCalendarsEpic,
  fetchMicrosoftAdminConsent,
  microsoftAdminManagedAccept,
  disconnectMicrosoftAdminConsentEpic,
  fetchMicrosoftManagedCalendarsEpic,
  shareRoutedCalendarEpic,
  hasSeenPersonalizationTooltip
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/meetings/epic.js